import service1 from '../../assets/images/service_1.png'
import service2 from '../../assets/images/service_2.png'
import service3 from '../../assets/images/service_3.png'
import service4 from '../../assets/images/service_4.png'
import arrowRight from '../../assets/images/arrow-right-white.svg'
import ServiceButton from '../ui/ServiceButton'

interface ServiceCard {
  id: number
  title: string
  description: string
  image: string
}

const services: ServiceCard[] = [
  {
    id: 1,
    title: "LAST-MILE DELIVERY",
    description: "Fast, local deliveries tailored for modern businesses.",
    image: service1
  },
  {
    id: 2,
    title: "REAL-TIME TRACKING",
    description: "Monitor order progress every step of the way.",
    image: service2
  },
  {
    id: 3,
    title: "MULTI-ZONE ROUTING",
    description: "Optimize delivery across zones, saving time and cost.",
    image: service3
  },
  {
    id: 4,
    title: "SCHEDULED PICKUPS",
    description: "Customers schedule pickups from their own address.",
    image: service4
  }
]

function Services() {
  return (
    <section className="bg-white py-20 px-4">
      <div className="container sm:px-10 px-3  mx-auto text-center">
        {/* Section Header */}
        <p className="text-[#F55109] text-sm font-semibold tracking-wider mb-4 uppercase">
          Our Services
        </p>
        
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-6 leading-tight" style={{ fontFamily: 'Antonio, sans-serif' }}>
          DESIGNED FOR DELIVERY, BUILT FOR{' '}
          <span className="text-[#F55109]">SCALE</span>
        </h2>
        
        <p className="text-gray-600 text-lg max-w-3xl mx-auto mb-16 leading-relaxed">
          From local drop-offs to real-time tracking, Speedyssey gives your business the
          tools to deliver better—zone by zone, doorstep by doorstep.
        </p>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {services.map((service) => (
            <div key={service.id} className="relative group overflow-hidden rounded-md">
              <div className="relative">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-96 object-cover transition-transform duration-300 group-hover:scale-105"
                />
                
                {/* Dark footer overlay */}
                <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-black/95 via-black/80 to-transparent" />
                
                {/* Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-8 flex items-center justify-between">
                  <div className="flex-1 text-left">
                    <h3 className="text-white text-2xl font-bold mb-2 text-left" style={{ fontFamily: 'Antonio, sans-serif' }}>
                      {service.title}
                    </h3>
                    <p className="text-white/90 text-base leading-relaxed text-left">
                      {service.description}
                    </p>
                  </div>
                  
                  {/* Arrow Icon - positioned on the right */}
                  <div className="ml-6 flex-shrink-0">
                    <div className="inline-flex items-center justify-center transition-all duration-300 group-hover:translate-x-2">
                      <img
                        src={arrowRight}
                        alt="Arrow right"
                        className="w-10 h-10"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* See All Services Button */}
        <div className="flex justify-center">
          <ServiceButton
            title="See All Services"
            onClick={() => {
              window.location.href = '/services';
            }}
          />
        </div>
      </div>
    </section>
  )
}

export default Services
